import React, { Component, PropTypes } from 'react'
import { Grid, Image } from 'semantic-ui-react'

import AsyncImage from '../../asyncImages/AsyncImage'

import '../../../node_modules/semantic-ui-css/components/grid.css'
import '../../../node_modules/semantic-ui-css/components/image.css'

export default class ThumbnailComponent extends Component {

  static propTypes = {
    handleClick: PropTypes.func.isRequired,
    icon: PropTypes.string.isRequired,
    iconAlt: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    thumbnail: PropTypes.string.isRequired,
  }

  render () {
    const { handleClick, icon, iconAlt, name, thumbnail } = this.props

    return (
      <Grid.Column textAlign='center' className='hvr-grow'>
        <AsyncImage
          alt={name}
          className='thumbnail'
          loaderSize='huge top40'
          src={thumbnail}
          onClick={handleClick}
        />
        <div className='no-margin'>
          <Image
            alt={`${iconAlt} icon`}
            centered
            className='seventyFiveWidthHeight galleryIconAlignment'
            onClick={handleClick}
            shape='circular'
            src={icon}
          />
        </div> {/* End Icon */}
        <p>{name}</p>
      </Grid.Column>
    )
  }
}



// WEBPACK FOOTER //
// ./src/gallery/components/ThumbnailComponent.js